module.exports = __webpack_public_path__ + "static/media/13_l_stena_0_0.041037a1.png";